import React from 'react'
import App from './App'
import { Provider } from './provider'

import { createRoot } from 'react-dom/client'

createRoot(document.getElementById('root')).render(
  <Provider>
    <App />
  </Provider>
)
